/* OjerasZero — interactividad propia (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.oz-reveal:not(.oz-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('oz-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('oz-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var eu = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    return eu + ' €';
  }

  // Formulario de compra: variantes + planes de suscripción + precio del botón y barra fija
  function initBuyForms() {
    document.querySelectorAll('[data-oz-buy]').forEach(function (form) {
      var dataEl = form.querySelector('[data-oz-variants]');
      var variants = [];
      try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) {}
      var fmt = form.getAttribute('data-money-format');
      var idInput = form.querySelector('[data-oz-variant-input]');
      var select = form.querySelector('[data-oz-variant-select]');
      var priceNow = form.querySelector('[data-oz-price-now]');
      var priceOld = form.querySelector('[data-oz-price-old]');
      var btnLabel = form.querySelector('[data-oz-btn-price]');
      var btn = form.querySelector('button[name="add"]');
      var stickyPrice = document.querySelectorAll('[data-oz-sticky-price="' + form.getAttribute('id') + '"]');

      function currentVariant() {
        var id = idInput ? parseInt(idInput.value, 10) : null;
        for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
        return variants[0];
      }
      function currentPlan() {
        var r = form.querySelector('input[name="selling_plan"]:checked');
        return r && r.value ? parseInt(r.value, 10) : null;
      }
      var qtyInput = form.querySelector('[data-oz-qty-input]');
      function packActual() {
        var r = form.querySelector('[data-oz-pack]:checked');
        var q = r ? parseInt(r.getAttribute('data-oz-qty') || '1', 10) : 1;
        var f = r ? parseFloat(r.getAttribute('data-oz-factor') || '1') : 1;
        return { q: q || 1, f: f || 1 };
      }
      function total(unit) { var pk = packActual(); return Math.round(unit * pk.q * pk.f); }
      var subInput = form.querySelector('input[name="selling_plan"][type="checkbox"]');
      var subPrecio = subInput ? subInput.closest('.oz-sub').querySelector('[data-oz-plan-price]') : null;
      var subDetalle = form.querySelector('[data-oz-plan-detalle-txt]');
      var detalleBase = subDetalle ? subDetalle.textContent : '';
      // Cada pack lleva su propio plan de suscripción (p. ej. 1 ud cada 2 meses, 3 uds cada 4 meses)
      function planDelPack() {
        var r = form.querySelector('[data-oz-pack]:checked');
        if (!r || !subInput) return;
        var pid = r.getAttribute('data-oz-plan');
        if (pid) { subInput.value = pid; if (subPrecio) subPrecio.setAttribute('data-oz-plan-price', pid); }
        if (subDetalle) subDetalle.textContent = r.getAttribute('data-oz-plan-detalle') || detalleBase;
      }
      function refresh() {
        var v = currentVariant();
        if (!v) return;
        planDelPack();
        var plan = currentPlan();
        var pk = packActual();
        if (qtyInput) qtyInput.value = pk.q;
        // Imagen del pack (p. ej. 3 botes con "GRATIS!") cuando se elige un pack de varias unidades
        var seccion = form.closest('.shopify-section');
        if (seccion && seccion.querySelector('[data-oz-pack-img]')) {
          var imgPack = seccion.querySelectorAll('[data-oz-pack-img]');
          if (pk.q > 1) imgPack.forEach(function (im) { im.loading = 'eager'; });
          seccion.classList.toggle('oz-pack-activo', pk.q > 1);
        }
        var price = v.price;
        if (plan && v.plans) {
          for (var i = 0; i < v.plans.length; i++) if (v.plans[i].id === plan) price = v.plans[i].price;
        }
        price = total(price);
        var txt = money(price, fmt);
        if (priceNow) priceNow.textContent = money(v.price, fmt);
        if (priceOld) {
          priceOld.textContent = v.compare && v.compare > v.price ? money(v.compare, fmt) : '';
        }
        if (btnLabel) btnLabel.textContent = txt;
        stickyPrice.forEach(function (el) { el.textContent = txt; });
        if (btn) {
          btn.disabled = !v.available;
          var labelEl = btn.querySelector('[data-oz-btn-text]');
          if (labelEl) labelEl.textContent = v.available ? labelEl.getAttribute('data-available') : labelEl.getAttribute('data-soldout');
        }
        document.querySelectorAll('button[form="' + form.getAttribute('id') + '"]').forEach(function (b) { b.disabled = !v.available; });
        // precios por plan en cada opción
        form.querySelectorAll('[data-oz-plan-price]').forEach(function (el) {
          var pid = el.getAttribute('data-oz-plan-price');
          var p = v.price;
          if (pid && v.plans) for (var j = 0; j < v.plans.length; j++) if (String(v.plans[j].id) === pid) p = v.plans[j].price;
          el.firstChild.nodeValue = money(total(p), fmt);
          var old = el.querySelector('[data-oz-plan-old]');
          if (old) old.textContent = money(total(v.price), fmt);
        });
      }
      if (select) select.addEventListener('change', function () { idInput.value = select.value; refresh(); });
      form.querySelectorAll('[data-oz-pack]').forEach(function (r) {
        r.addEventListener('change', function () { if (r.checked) { idInput.value = r.value; refresh(); } });
      });
      form.addEventListener('change', function (e) { if (e.target.name === 'selling_plan') refresh(); });
      refresh();
    });
    if (document.querySelector('.oz-sticky')) {
      document.body.classList.add('oz-has-sticky');
      // En la vista previa de Shopify hay una barra negra abajo: subimos el botón fijo para que no lo tape
      var mirarBarra = function () {
        var barra = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
        document.documentElement.style.setProperty('--oz-preview-bar', barra ? Math.round(barra.getBoundingClientRect().height) + 'px' : '0px');
      };
      mirarBarra(); setTimeout(mirarBarra, 1500); setTimeout(mirarBarra, 4000);
    }
  }

  function initGallery() {
    document.querySelectorAll('[data-oz-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-oz-main]');
      if (!main) return;
      g.querySelectorAll('[data-oz-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          g.querySelectorAll('[data-oz-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          main.style.opacity = 0;
          var wrap = g.querySelector('[data-oz-main-wrap]');
          setTimeout(function () {
            if (wrap) wrap.classList.toggle('oz-gallery__main--flotante', t.getAttribute('data-flotante') === '1');
            main.src = t.getAttribute('data-src');
            main.srcset = t.getAttribute('data-srcset') || '';
            main.alt = t.getAttribute('data-alt') || '';
            main.style.opacity = 1;
          }, 180);
        });
      });
    });
  }

  // Plazo de entrega: suma días laborables (lunes a viernes) a hoy
  function initEntrega() {
    document.querySelectorAll('[data-oz-entrega]').forEach(function (el) {
      var out = el.querySelector('[data-oz-entrega-fechas]');
      if (!out) return;
      function sumar(dias) {
        var d = new Date(); var n = 0;
        while (n < dias) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n++; }
        return d;
      }
      var fmt = function (d) { return d.toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/[.,]/g, ''); };
      var min = parseInt(el.getAttribute('data-min'), 10) || 3;
      var max = parseInt(el.getAttribute('data-max'), 10) || 10;
      out.textContent = fmt(sumar(min)) + ' y el ' + fmt(sumar(max));
    });
  }

  // Carrusel de reseñas con flechas
  function initCarrusel() {
    document.querySelectorAll('[data-oz-carrusel]').forEach(function (c) {
      var pista = c.querySelector('.oz-reviews__grid');
      if (!pista || c.dataset.ozListo) return;
      c.dataset.ozListo = '1';
      var paso = function () { var card = pista.querySelector('.oz-review'); return card ? card.getBoundingClientRect().width + 20 : 300; };
      var prev = c.querySelector('[data-oz-prev]'), next = c.querySelector('[data-oz-next]');
      if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: 'smooth' }); });
    });
  }

  // Burbujas al pulsar packs, opciones de compra y botones (cantidad y tamaño según el elemento)
  function initBurbujasClick() {
    if (reduce || document.documentElement.dataset.ozPop) return;
    document.documentElement.dataset.ozPop = '1';
    document.addEventListener('pointerdown', function (e) {
      var el = e.target.closest('.oz-pack, .oz-plan, .oz-btn');
      if (!el || el.disabled) return;
      var capa = el.querySelector(':scope > .oz-pop-capa');
      if (!capa) { capa = document.createElement('span'); capa.className = 'oz-pop-capa'; capa.setAttribute('aria-hidden', 'true'); el.appendChild(capa); }
      var r = el.getBoundingClientRect();
      var base = Math.min(r.width, r.height);
      var n = Math.max(6, Math.min(16, Math.round(r.width / 24)));
      var x = e.clientX - r.left, y = e.clientY - r.top;
      for (var i = 0; i < n; i++) {
        var b = document.createElement('span');
        var tam = base * (0.12 + Math.random() * 0.28);
        var ang = Math.random() * Math.PI * 2;
        var dist = base * (0.35 + Math.random() * 0.7);
        b.className = 'oz-pop';
        b.style.cssText = 'left:' + x + 'px;top:' + y + 'px;width:' + tam + 'px;height:' + tam + 'px;--dx:' + (Math.cos(ang) * dist).toFixed(1) + 'px;--dy:' + (Math.sin(ang) * dist - base * 0.3).toFixed(1) + 'px;--dur:' + (0.7 + Math.random() * 0.5).toFixed(2) + 's';
        capa.appendChild(b);
        setTimeout(function (n) { return function () { n.remove(); }; }(b), 1400);
      }
    }, { passive: true });
  }

  // Un solo botón de compra en móvil: el fijo se esconde mientras el botón de la página está en pantalla
  function initStickyUnico() {
    document.querySelectorAll('.oz-sticky').forEach(function (st) {
      // Sacamos el botón fijo de su sección para que ninguna otra sección (p. ej. las estrellas) lo tape
      if (st.parentElement !== document.body) {
        document.querySelectorAll('body > .oz-sticky').forEach(function (viejo) { viejo.remove(); });
        document.body.appendChild(st);
      }
      var btn = st.querySelector('button[form]');
      var form = btn && document.getElementById(btn.getAttribute('form'));
      var principal = form && form.querySelector('button[name="add"]');
      if (!principal || st.dataset.ozObs) return;
      st.dataset.ozObs = '1';
      var revisar = function () {
        var r = principal.getBoundingClientRect();
        // Zona realmente visible: por debajo del menú (que al subir tapa la parte de arriba) y por encima del borde inferior
        var arriba = 0;
        var cab = document.querySelector('.section-header, sticky-header, .header-wrapper');
        if (cab) { var hc = cab.getBoundingClientRect(); if (hc.bottom > 0) arriba = hc.bottom; }
        var visible = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, arriba);
        // Solo se esconde cuando el botón de la página se ve casi entero
        var seVe = visible >= r.height * 0.8;
        if (seVe) {
          // ...y que no lo tape nada fijo (pastilla del menú, barra de oferta...)
          var enMedio = document.elementFromPoint(r.left + r.width / 2, Math.max(r.top, arriba) + Math.min(r.height, visible) / 2);
          seVe = !!enMedio && principal.contains(enMedio);
        }
        st.classList.toggle('is-oculto', seVe);
      };
      if ('IntersectionObserver' in window) new IntersectionObserver(revisar, { threshold: [0, 0.01, 1] }).observe(principal);
      var tRevisar;
      window.addEventListener('scroll', function () { revisar(); clearTimeout(tRevisar); tRevisar = setTimeout(revisar, 450); }, { passive: true });
      window.addEventListener('resize', revisar);
      revisar();
    });
  }

  // Botones "#comprar": sube hasta arriba del todo (el bloque de compra está en la primera pantalla)
  function initIrAComprar() {
    if (document.documentElement.dataset.ozIr) return;
    document.documentElement.dataset.ozIr = '1';
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href="#comprar"], a[href$="/#comprar"]');
      if (!a) return;
      var destino = document.getElementById('comprar');
      if (!destino) return;
      e.preventDefault();
      var primera = document.querySelector('#MainContent > .shopify-section');
      var y = (primera && primera.contains(destino)) ? 0 : destino.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: y, behavior: 'smooth' });
      if (history.replaceState) history.replaceState(null, '', location.pathname + location.search);
    });
  }
  // Comparador antes/después: la barra se mueve sola despacio y se puede arrastrar
  function initComparador() {
    document.querySelectorAll('[data-oz-comp]').forEach(function (c) {
      if (c.dataset.ozListo) return;
      c.dataset.ozListo = '1';
      var range = c.querySelector('.oz-comp__range');
      var pausa = 0, t0 = performance.now();
      function set(v) { c.style.setProperty('--pos', v + '%'); if (range) range.value = v; }
      function tocar() { pausa = performance.now() + 5000; }
      if (range) {
        range.addEventListener('input', function () { tocar(); c.style.setProperty('--pos', range.value + '%'); });
        ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) { range.addEventListener(ev, tocar, { passive: true }); });
      }
      if (reduce) return;
      var fase = 0, ultimo = null;
      function paso(t) {
        var sec = c.closest('.shopify-section');
        if (ultimo !== null && t > pausa && !(sec && sec.classList.contains('oz-fuera'))) {
          fase += (t - ultimo) / 1000 * (Math.PI * 2 / 9);
          set((50 + Math.sin(fase) * 32).toFixed(2));
        }
        ultimo = t;
        requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    });
  }
  // Rendimiento: pausa las animaciones de las secciones que no se ven
  function initPausaFuera() {
    if (!('IntersectionObserver' in window) || document.documentElement.dataset.ozPausa) return;
    document.documentElement.dataset.ozPausa = '1';
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var fuera = !e.isIntersecting;
        e.target.classList.toggle('oz-fuera', fuera);
        e.target.querySelectorAll('svg').forEach(function (svg) {
          if (svg.pauseAnimations) { fuera ? svg.pauseAnimations() : svg.unpauseAnimations(); }
        });
      });
    }, { rootMargin: '150px 0px' });
    document.querySelectorAll('#MainContent > .shopify-section, .shopify-section-group-footer-group').forEach(function (sec) { io.observe(sec); });
  }
  // Desplegables suaves: animan la altura al abrir y cerrar (no se abren de golpe)
  function initDesplegables() {
    if (document.documentElement.dataset.ozDesp) return;
    document.documentElement.dataset.ozDesp = '1';
    document.addEventListener('click', function (e) {
      var sum = e.target.closest('summary');
      if (!sum) return;
      var det = sum.parentElement;
      if (!det || det.tagName !== 'DETAILS' || !det.closest('#MainContent') || det.hasAttribute('data-oz-sin-anim')) return;
      if (reduce || !det.animate) return;
      e.preventDefault();
      if (det._ozAnim) det._ozAnim.cancel();
      var inicio = det.offsetHeight;
      det.style.overflow = 'hidden';
      var abrir = !det.open;
      if (abrir) det.open = true;
      var fin = abrir ? det.scrollHeight : sum.offsetHeight;
      if (!abrir) { det.classList.add('oz-cerrando'); }
      var anim = det.animate({ height: [inicio + 'px', fin + 'px'] }, { duration: abrir ? 420 : 340, easing: 'cubic-bezier(.22,1,.36,1)' });
      det._ozAnim = anim;
      var hecho = false;
      function terminar(ok) {
        if (hecho) return; hecho = true;
        clearTimeout(t);
        if (anim.playState !== 'finished' && anim.playState !== 'idle') { try { anim.cancel(); } catch (err) {} }
        if (det._ozAnim === anim) det._ozAnim = null;
        if (ok && !abrir) det.open = false;
        det.classList.remove('oz-cerrando');
        det.style.overflow = '';
      }
      var t = setTimeout(function () { terminar(true); }, (abrir ? 420 : 340) + 80);
      anim.finished.then(function () { terminar(true); }, function () { terminar(false); });
    });
  }
  // Oferta por tiempo limitado: cuenta atrás hasta una fecha fija; al terminar, desaparece
  function initOferta() {
    var els = document.querySelectorAll('[data-oz-oferta][data-oz-fin]');
    if (!els.length || document.documentElement.dataset.ozOferta) return;
    document.documentElement.dataset.ozOferta = '1';
    var fin = Date.parse(els[0].getAttribute('data-oz-fin'));
    if (isNaN(fin)) return;
    function dos(n) { return (n < 10 ? '0' : '') + n; }
    function tic() {
      var r = Math.floor((fin - Date.now()) / 1000);
      if (r <= 0) {
        document.querySelectorAll('[data-oz-oferta]').forEach(function (e) { e.remove(); });
        document.documentElement.classList.remove('oz-con-oferta');
        return false;
      }
      var h = Math.floor(r / 3600), m = Math.floor((r % 3600) / 60), s = r % 60;
      var t = dos(h) + ':' + dos(m) + ':' + dos(s);
      document.querySelectorAll('[data-oz-cuenta]').forEach(function (e) { e.textContent = t; });
      return true;
    }
    if (tic()) { document.documentElement.classList.add('oz-con-oferta'); var iv = setInterval(function () { if (!tic()) clearInterval(iv); }, 1000); }
  }
  function initAll() { initOferta(); initDesplegables(); initPausaFuera(); initComparador(); initIrAComprar(); initReveal(); initBuyForms(); initGallery(); initEntrega(); initCarrusel(); initBurbujasClick(); initStickyUnico(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  // Editor de Shopify: re-inicializar al recargar una sección
  document.addEventListener('shopify:section:load', function () { initComparador(); initReveal(); initBuyForms(); initGallery(); initEntrega(); initCarrusel(); });
})();
